var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6663 3.33333H5.33301C4.96482 3.33333 4.66634 3.63181 4.66634 4V6.66667C4.66634 8.50762 6.15873 10 7.99967 10C9.84062 10 11.333 8.50762 11.333 6.66667V4C11.333 3.63181 11.0345 3.33333 10.6663 3.33333ZM5.33301 2C4.22844 2 3.33301 2.89543 3.33301 4V6.66667C3.33301 9.244 5.42235 11.3333 7.99967 11.3333C10.577 11.3333 12.6663 9.244 12.6663 6.66667V4C12.6663 2.89543 11.7709 2 10.6663 2H5.33301Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666992 5.33331C0.666992 4.22874 1.56242 3.33331 2.66699 3.33331H4.66699V8.66665H3.33366C1.8609 8.66665 0.666992 7.47274 0.666992 5.99998V5.33331ZM2.66699 4.66665H3.33366V7.33331C2.59728 7.33331 2.00033 6.73636 2.00033 5.99998V5.33331C2.00033 4.96512 2.2988 4.66665 2.66699 4.66665Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3337 5.33331C15.3337 4.22874 14.4382 3.33331 13.3337 3.33331H11.3337V8.66665H12.667C14.1398 8.66665 15.3337 7.47274 15.3337 5.99998V5.33331ZM13.3337 4.66665H12.667V7.33331C13.4034 7.33331 14.0003 6.73636 14.0003 5.99998V5.33331C14.0003 4.96512 13.7018 4.66665 13.3337 4.66665Z",
    fill: "#FCFCFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 10C7.63148 10 7.33301 10.2985 7.33301 10.6667V12.6667H5.99967C5.63148 12.6667 5.33301 12.9651 5.33301 13.3333C5.33301 13.7015 5.63148 14 5.99967 14H9.99967C10.3679 14 10.6663 13.7015 10.6663 13.3333C10.6663 12.9651 10.3679 12.6667 9.99967 12.6667H8.66634V10.6667C8.66634 10.2985 8.36786 10 7.99967 10Z",
    fill: "#FCFCFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.0c94f74e.svg";
export { ForwardRef as ReactComponent };